<script lang="ts">
  import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
  import Fa from 'svelte-fa';
  import type TurnGraph from '../model/turnGraph';

  export let icon: IconDefinition;
  export let graph: TurnGraph;
  export let percent = false;


  function format(n: number, diff=false): string {
    let sign = diff && n >= 0 ? "+" : "";

    if (percent)
      return `${sign}${Math.round(n * 100) / 100}%`;
    else
      return `${sign}${Math.round(n * 100) / 100}`;
  }
</script>

<span>
  <Fa {icon} size="lg"/>
  {format(graph.latest + graph.queue, percent=percent)}
  {#if graph.latestChange !== null}
    <span class="text-secondary">
      {format(graph.latestChange, true)}
    </span>
  {/if}
</span>